import { KpiMetric, type KpiMetricProps } from '@/components/kpi';
import { COLOR_GREEN_100, COLOR_RED_300 } from '@/styles/palette';

const getColor = ({ best, worst }: { best: boolean; worst: boolean }) => {
  if (best) {
    return COLOR_GREEN_100;
  }
  if (worst) {
    return COLOR_RED_300;
  }
  return undefined;
};

type Props = KpiMetricProps & {
  isBest: boolean;
  isWorst: boolean;
};

const FitScoreMetricCell = ({ isBest, isWorst, ...rest }: Props) => {
  return (
    <KpiMetric
      color={getColor({
        best: isBest,
        worst: isWorst,
      })}
      {...rest}
    />
  );
};

export default FitScoreMetricCell;
